export const faqItems = [
  {
    q: "宅宅资源库的合集、索引和归档有什么区别？",
    a: "合集把同一系列或同一作者的多部资源汇总在一篇整理贴里；索引按类别列出可查的目录入口；归档则按系列、作者或时间归类，方便直接查表批量收藏。三种形式互为补充，帮你把零散资源整理得更清晰。",
  },
  {
    q: "想按系列批量收藏，应该从哪个板块开始？",
    a: "建议先从「归档」页开始，按系列或作者筛选即可看到已整理的目录；若已有明确目标，也可直接在「合集」页按类别查找对应的整理贴，然后顺着章节逐条收藏。",
  },
  {
    q: "整理贴多久更新一次，会不会有遗漏？",
    a: "整理贴会持续补全并更新目录，新公开的资料会尽快汇总进来。部分条目可能仍在核对中，若发现缺失或链接失效，可在文章评论区反馈，我们会及时核实并补齐。",
  },
  {
    q: "这里的资源可以转载或商用吗？",
    a: "本站仅提供整理索引与目录，资源仅供个人收藏与研究使用，请勿用于商业用途。转载整理内容时请注明来源与整理者。",
  },
  {
    q: "如何在站内快速找到某个系列或作者？",
    a: "你可以在「归档」页使用筛选与搜索功能，按系列归档、作者归档或作品归档进行筛选；也可以浏览「合集」页的分类标签快速定位感兴趣的板块。",
  },
];